import api from '../api';
const axiosConfig = {
    headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
    },
};

const BASE_URL = process.env.REACT_APP_API_URL;

const NotificationService = {

    getAll: async ({ currentPage, limit, search, offset, filters }) => {
        try {
            let filterParams = [];
            for (const key in filters) {
                if (filters.hasOwnProperty(key)) {
                    filterParams += `&filters[${encodeURIComponent(key)}]=${encodeURIComponent(filters[key])}`;
                }
            }

            return await api.get(`${BASE_URL}/notifications?page=${currentPage}&limit=${limit}&search=${search}&offset=${offset}${filterParams}`, axiosConfig)
        } catch (error) {
            console.log("Error in getting notifications", [error])
            throw new Error(error.response?.data?.message || error.message);
        }
    },

    get: async (id) => {
        try {
            return await api.get(`${BASE_URL}/notifications/${id}`, axiosConfig);
        } catch (error) {
            console.log("Error in getting notifications detail.", [error]);
            throw new Error(error.response?.data?.message || error.message);
        }
    },
    getByUser: async (id) => {
        try {
            return await api.get(`${BASE_URL}/notifications/user/${id}`, axiosConfig);
        } catch (error) {
            console.log("Error in getting user notifications detail.", [error]);
            throw new Error(error.response?.data?.message || error.message);
        }
    },
    create: async (data) => {
        try {
            return await api.post(`${BASE_URL}/notifications`, data, axiosConfig);
        } catch (error) {
            console.log("Error in creating notifications.", [error]);
            throw new Error(error.response?.data?.message || error.message);
        }
    },

    delete: async (id) => {
        try {
            return await api.delete(`${BASE_URL}/notifications/${id}`, axiosConfig);
        } catch (error) {
            console.log("Error in deleting notifications.", [error]);
            throw new Error(error.response?.data?.message || error.message);
        }
    },

    markAsRead: async (id) => {
        try {
            return await api.put(`${BASE_URL}/notifications/mark-as-read/${id}`, axiosConfig);
        } catch (error) {
            console.log("Error in marking notifications as read.", [error]);
            throw new Error(error.response?.data?.message || error.message);
        }
    },
}

export default NotificationService